import { ReactNode, createContext, useState, useCallback } from 'react';

type PageHeaderState = {
  title: string;
  onBack: (() => void) | undefined;
};

type PageHeaderContextType = PageHeaderState & {
  setHeader: (title: string, onBack?: () => void) => void;
};

const PageHeaderContext = createContext<PageHeaderContextType>({
  title: '',
  onBack: undefined,
  setHeader: () => {},
});

const PageHeaderProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<PageHeaderState>({ title: '', onBack: undefined });

  const setHeader = useCallback((newTitle: string, newOnBack?: () => void) => {
    setState({ title: newTitle, onBack: newOnBack });
  }, []);

  return (
    <PageHeaderContext.Provider value={{ title: state.title, onBack: state.onBack, setHeader }}>
      {children}
    </PageHeaderContext.Provider>
  );
};

export { PageHeaderContext, PageHeaderProvider };
